<template>
	<div id="costStatistics">
		<div class="public-content">
			<div class="form-item-public">
				<el-form inline label-position="right">
					<el-form-item label='费用统计表：'>
						<div @click.stop="boxHide = !boxHide" >
							<el-input  size="small" readonly v-model='yearPeriodsText' style='width: 180px;'>
								<el-button slot="append" icon="el-icon-search" class='el_primary' size='small'
								>筛选</el-button>
							</el-input>
						</div>
						<div class='searchBoxStyle' @click.stop='returnFalse'>
							<transition name="el-zoom-in-top">
								<div v-show="boxHide" class="search_container">
									<el-form label-position="right">
										<el-form-item label='期间：'>
											<el-date-picker
												v-model="searchForm.year"
												style='width: 180px;'
												type="year"
												size="mini"
												class="year-editor"
												placeholder="选择年"
												:clearable="false"
												:picker-options="pickerBeginDateBefore"
												@change="handleYearChange">
											</el-date-picker>
										</el-form-item>
										<el-form-item label='科目：' >
											<el-select size="mini" placeholder="请选择"	v-model="searchForm.content" style='width: 180px;' @change='handleSelectChange' filterable clearable>
												<el-option
											    	v-for="item in subjectData"
											    	:key="item.id"
											    	:label="item.labels"
											    	:value="item.id">
											    </el-option>
											</el-select>
										</el-form-item>
										<el-form-item>
											<el-checkbox class='el_checkbox' v-model='searchForm.isShowJunior' @change='handlerCheckbox'>显示下级科目</el-checkbox>
										</el-form-item>
										<div class="search_container_footer">
											<el-button size='mini' class='secondaryButton' @click='resetList'>重置</el-button>
											<el-button size='mini' class='minButton' @click='getTableList'>搜索</el-button>
										</div>
									</el-form>
								</div>
							</transition>
						</div>
					</el-form-item>
					<el-form-item class='right-position'>
						<print-operation
							:formData="printForm"
							:showContinuit="false"
						></print-operation>
						<el-button size='mini'  @click="handleDownload">
							导出
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<public-table :table='tableData'></public-table>
		</div>
	</div>
</template>
<script >
	import publicTable from '@/components/publicTable'
	import {currencys} from '@/assets/utils/currencyFormat'
	import printOperation from '@/components/print'
	export default {
		components: {
			publicTable,
			printOperation
		},
		data() {
			return {
				isFirstActive: false,
				printForm: {        // 打印参数
					data: {
						year: '',
						content: '',
						isShowJunior: '',
					},
					url: '/createPDF/printCostStatistiscs',
					continuityUrl: '/createPDF/printCostStatistiscs'
				},
				pickerBeginDateBefore: {
					disabledDate: (time) => {
						let beginStartDateVal = this.getAccountPeriod.startTimeStamp;
						let beginEndDateVal = this.getAccountPeriod.endTimeStamp;

						if (beginEndDateVal && beginEndDateVal) {
							return time.getTime() > beginEndDateVal || time.getTime() < beginStartDateVal
						}
					}
				},
				form: {
					year: '',
					defaultStartDate: '',
					defaultEndDate: ''
				},
				searchForm: {
					isShowJunior: '',
					content: '',
					year: ''
				},
				nowYear: '',
				boxHide: false,         // 检索弹框
				yearPeriodsText: '',       //
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '费用类型',
						value: 'name',
						show: 'normal'
					},{
						label: '1月',
						formatter: this.formatter,
						value: 'jan',
						show: 'normal'
					},{
						label: '2月',
						formatter: this.formatter,
						value: 'feb',
						show: 'normal'
					},{
						label: '3月',
						formatter: this.formatter,
						value: 'mar',
						show: 'normal'
					},{
						label: '4月',
						formatter: this.formatter,
						value: 'apr',
						show: 'normal'
					},{
						label: '5月',
						formatter: this.formatter,
						value: 'may',
						show: 'normal',
					},{
						label: '6月',
						formatter: this.formatter,
						value: 'jun',
						show: 'normal'
					},{
						label: '7月',
						formatter: this.formatter,
						value: 'jul',
						show: 'normal'
					},{
						label: '8月',
						formatter: this.formatter,
						value: 'aug',
						show: 'normal'
					},{
						label: '9月',
						formatter: this.formatter,
						value: 'sep',
						show: 'normal'
					},{
						label: '10月',
						formatter: this.formatter,
						value: 'oct',
						show: 'normal'
					},{
						label: '11月',
						formatter: this.formatter,
						value: 'nov',
						show: 'normal'
					},{
						label: '12月',
						formatter: this.formatter,
						value: 'december',
						show: 'normal'
					},{
						label: '本年累计',
						formatter: this.formatter,
						value: 'remainingSum',
						show: 'normal',
					}],
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					},
					getSummaries: this.getSummaries,			// 自定义合计方法
				},

			}
		},
		created() {
			this.getAccountPeriods();
			this.getAllSubject();
		},
		computed: {
			getAccountPeriod() {
				return this.$store.state.accountInfo.yearPeriods;

			},
			// 科目
			subjectData() {
				return this.$store.state.getSubjectId.AllSubjectList
			},
			getClickCache() {
				return this.$store.state.loadstatus.isClickCache;
			},
		},

		activated() {
			if(this.getClickCache && this.isFirstActive) {
				this.getTableList();
			}
			this.isFirstActive = true;
		},
		methods: {
			// checkbox
			handlerCheckbox(val) {
				this.printForm.data = Object.assign(this.printForm.data , {
					year:this.nowYear,
					isShowJunior:val,
				});
			},
			// 自定义合计
			getSummaries (param) {
				const { columns, data } = param;
				const sums = [];

				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					// if(index === 13) {
					// 	return;
					// }
					const values = data.map(item => {
						return Number(item[column.property])
					});

					if (!values.every(value => {isNaN(value)})) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if(!isNaN(value)) {
								prev = Number(prev)
								if(!(parseFloat(prev)+parseFloat(curr))) {
									return '';
								}else {
									return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
								}
							} else {
								return parseFloat(prev).toFixed(2);
							}
						}, 0);
					} else {
						sums[index] = '';
					}
				});
				if(sums) {
					return sums;
				}else {
					return '';
				}
			},
			// 表格格式化
			formatter(row, column, cellValue, index) {
				if(!row[column.property]) {
					return "";
				}else {
					return currencys(row[column.property]);
				}
			},
			// 导出
			handleDownload (){
				const params = {
					cid: sessionStorage.cid,
					token: sessionStorage.token,
					year: this.nowYear,
					content: this.searchForm.content,
					isShowJunior: this.searchForm.isShowJunior,
				}

				const router = this.$router.resolve({
					path: '/export/costStatisticsExport',
					query: params
				})

				window.open(this.$rootUrl + router.href, '_blank');
			},
			// 阻止默认事件
			returnFalse() {
				return false;
			},
			// 重置科目
			resetList() {
				this.searchForm = Object.assign(this.searchForm , {
					isShowJunior: '',
					content: '',
				})
			},
			// 查询所有科目
			getAllSubject () {
				if (!this.subjectData) {
					this.$store.dispatch('getAllSubject')
				}
			},
			// 获取会计期间/初始化数据
			getAccountPeriods() {
				let accountInfo = this.$getSessionStorage('accountInfo')
				if(!this.getAccountPeriod) {
					this.$store.dispatch('getAllYearPeriodsData')
				}
				this.searchForm.year = accountInfo.yearPeriodTimeStamp;
				this.nowYear = this.$util.formatDate.format(accountInfo.yearPeriodTimeStamp , 'yyyy');
				this.yearPeriodsText = this.$util.formatDate.format(accountInfo.yearPeriodTimeStamp , 'yyyy年');
				this.printForm.data.year = this.nowYear;
				this.getTableList();
			},
			// 选择期数
			handleYearChange (val) {
				this.nowYear =  this.$util.formatDate.format(val , 'yyyy');
				this.yearPeriodsText = this.$util.formatDate.format(val , 'yyyy年');
				this.printForm.data = Object.assign(this.printForm.data , {
					year:this.nowYear,
					content: this.searchForm.content
				});
			},
			handleSelectChange(val){
				this.printForm.data = Object.assign(this.printForm.data , {
					year:this.nowYear,
					content: val
				});
			},
			// 获取费用统计表
			getTableList() {
				this.boxHide = false;
				this.searchForm.year = this.nowYear;
				try {
					this.tableData.loading = true;

					this.$http.post('reportform/costStatistiscs' , this.searchForm).then(res=>{
						this.tableData.loading = false;
						if(res) {
							if(res.data.data.length) {
								this.tableData.data = res.data.data.map(i=>{
									for (const j in i) {
										if (typeof i[j] === 'number') {
											i[j] = i[j] == 0 ? '' : i[j];
										}
									}
									i.remainingSum = Number(i.apr)+Number(i.aug)+Number(i.december)+Number(i.feb)+Number(i.jan)+Number(i.jul)+Number(i.jun)+Number(i.mar)+Number(i.may)+Number(i.nov)+Number(i.oct)+Number(i.sep);

									return i;
								})
								if(this.searchForm.isShowJunior) {
									this.tableData.hasShowSummary = false;
								}else {
									this.tableData.hasShowSummary = true;
								}
							}
						}
					})
				}catch(e) {
					this.tableData.loading = false;
				}
			},
			// 点击空白页消失
			clickBody() {
				this.boxHide = false;
			},
		},
		mounted() {

		},
		watch: {
			boxHide(val){
				val?document.body.addEventListener('click', this.clickBody):document.body.removeEventListener('click', this.clickBody)
			},
			getAccountPeriod(val) {
				 this.form.defaultStartDate = val.startTimeStamp;
				 this.form.defaultEndDate = val.endTimeStamp;
			}
		},
	}
</script>
<style lang='less' scoped>
	.searchBoxStyle {
		position: absolute;
		z-index: 6;
		.search_container {
			width: 250px;
			padding: 20px 30px 20px;
			background: #fff;
			border: 1px solid #ddd;
			.el_checkbox {
				margin-left: 55px;
			}
			.search_container_footer {
				text-align: center;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/pages/reportForm/costStatistics.vue